import PDV from "@/pages/pdv/Pdv";

export default [
  {
    path: "/pdv",
    name: "PDV",
    component: PDV,
    meta: { fullscreen: true },
  },
];
